<div
  class="svg-icon"
  [inlineSVG]="'/assets/icons/transport/' + value + '.svg'">
